import toast from "@/utils/toast";

const whiteTypes = ["image/jpeg"];

export function getImageFormData(inputElement) {
  const formData = new FormData();
  const file = inputElement.files[0];
  if (!file) {
    throw new Error("获取文件失败");
  }
  if (whiteTypes.indexOf(file.type) < 0) {
    toast("只能发送png、jpeg类型图片");
    throw new Error("获取文件失败");
  }
  formData.append(file.name, file);
  return formData;
}

export function getImageFile(inputElement) {
  const file = inputElement.files[0];
  if (!file) {
    toast("获取文件失败");
    throw new Error("获取文件失败");
  }
  if (whiteTypes.indexOf(file.type) < 0) {
    toast("只能上传png、jpeg类型图片");
    throw new Error("获取文件失败");
  }
  return file;
}

export function getImageBase64(inputElement) {
  return new Promise((resolve, reject) => {
    const file = inputElement.files[0];
    if (!file) {
      toast("获取文件失败");
      reject("获取文件失败");
    }
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = event => {
      resolve(event.target.result);
    };
  });
}
